import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export const PasswordInput = ({ className = "", testId, ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative mt-1.5">
      <input {...props} type={show ? "text" : "password"} className={`w-full pr-12 ${className}`} data-testid={testId} />
      <button type="button" onClick={() => setShow(!show)} aria-label={show ? "Ocultar contraseña" : "Ver contraseña"}
        className="absolute right-1.5 top-1/2 -translate-y-1/2 p-2 text-slate-500 hover:text-[#0B1D3A] transition-colors" data-testid={`${testId}-toggle`}>
        {show ? <EyeOff size={20} /> : <Eye size={20} />}
      </button>
    </div>
  );
};
